//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MenuTree',
  props: {
    treeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  watch: {
    treeData: {
      handler: function handler(nVal, oVal) {
        var _this = this;
        this.$nextTick(function () {
          if (nVal.length) {
            var value = nVal[0].value;
            _this.$refs.tree.setCurrentKey(value);
          }
        });
      },
      deep: true
    }
  },
  methods: {
    // tree节点点击
    handleClick: function handleClick(node, data) {
      this.$emit('frameId', node.value);
    }
  }
};